
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/host",
      function () {
        return require("private-next-pages/host/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/host"])
      });
    }
  